import {
  getAfterLeaseVehiclesOffers,
  getAllMakesAndModels,
} from "../../../services";

export const PARTNER_ELECTRIC_MAX_RABAT_PERCENT = 5;

const ELECTRIC_FUEL_TYPE = 5;
const MAX_RESULTS = 1000;

const normalizeMake = (text) => (text || "").toLowerCase().replace(/[-\s]/g, " ").trim();

export const splitMakeModel = (makeModel, knownMakes = []) => {
  const text = (makeModel || "").trim();
  const normalizedText = normalizeMake(text);
  const match = knownMakes
    .map((make) => normalizeMake(make))
    .filter((make) => make && (normalizedText === make || normalizedText.startsWith(make + " ")))
    .sort((a, b) => b.length - a.length)[0];

  if (match) {
    return {
      make: text.substring(0, match.length).trim(),
      model: text.substring(match.length).trim(),
    };
  }

  const [make, ...rest] = text.split(/\s+/);
  return { make: make || "", model: rest.join(" ") };
};

const getOfferPrice = (tail) =>
  tail.FinalPriceBrutto > 0 ? tail.FinalPriceBrutto : tail.TotalPriceBrutto;

export const fetchPartnerElectricOffers = async () => {
  const [offersRes, makesRes] = await Promise.all([
    getAfterLeaseVehiclesOffers({
      FuelTypes: [ELECTRIC_FUEL_TYPE],
      Page: 1,
      ResultsPerPage: MAX_RESULTS,
    }),
    getAllMakesAndModels().catch(() => null),
  ]);

  const knownMakes = (makesRes?.data || []).map((item) => item.Make).filter(Boolean);
  const tails = offersRes?.data?.Tails || [];

  return tails
    .filter((tail) => !tail.Reservation)
    .map((tail) => {
      const { make, model } = splitMakeModel(tail.MakeModel, knownMakes);
      return {
        auctionId: tail.AuctionId,
        make,
        model,
        type: tail.Type,
        year: tail.Year,
        mileage: tail.Mileage,
        price: getOfferPrice(tail),
      };
    })
    .filter((offer) => offer.auctionId && offer.make && offer.price > 0);
};

export const getPartnerElectricOfferById = (offers, auctionId) =>
  (offers || []).find((offer) => String(offer.auctionId) === String(auctionId));

export const getPartnerElectricMinPrice = (offer) => {
  if (!offer) return 0;
  return Math.ceil(offer.price * (1 - PARTNER_ELECTRIC_MAX_RABAT_PERCENT / 100));
};

const sortPl = (a, b) => a.localeCompare(b, "pl");

export const getPartnerElectricMakeItems = (offers) =>
  [...new Set((offers || []).map((offer) => offer.make))]
    .sort(sortPl)
    .map((make) => ({ label: make, value: make }));

export const getPartnerElectricModelItems = (offers, make) =>
  [...new Set((offers || []).filter((offer) => offer.make === make).map((offer) => offer.model))]
    .sort(sortPl)
    .map((model) => ({ label: model, value: model }));

export const getPartnerElectricOfferItems = (offers, make, model) =>
  (offers || [])
    .filter((offer) => offer.make === make && offer.model === model)
    .map((offer) => ({
      label: String(offer.auctionId),
      value: String(offer.auctionId),
      additionalText: offer.type,
    }));
